import React from 'react'

import './detailQuote.css'
import ProductsTable from '../ProductsTable/ProductsTable'
import { t } from 'i18next'
import NoImage from '../../../../Assets/Images/Logos/no-image.png'
import Loading from 'Components/Loading'

const getQuoteDocumentNumber = quote =>
  quote?.DocumentNumber ||
  quote?.documentNumber ||
  quote?.Description ||
  quote?.Number ||
  quote?.QuoteNumber ||
  quote?.DocNumber ||
  ''

export default function DetailQuote({
  quote,
  products,
  isLoadingDetailQuote,
  showDiscount,
}) {
  const quoteDocumentNumber = getQuoteDocumentNumber(quote)
  const columns = [
    {
      Header: t('CUSTOMER_DISPLAY.REFERENCE_HEADER'),
      accessor: t('CUSTOMER_DISPLAY.REFERENCE_ACCESOR'),
      width: '10%',
    },
    {
      Header: t('CUSTOMER_DISPLAY.DESCRIPTION_LABEL'),
      accessor: 'description', // o el nombre real del campo
      width: '40%',
      Cell: ({ row }) => {
        const description =
          row.original[t('CUSTOMER_DISPLAY.DESCRIPTION_ACCESOR')]
        const image = row.original.image || NoImage
        return (
          <div className="detail-products-table-description-totals">
            {image && (
              <img
                src={image}
                alt={description}
                className="img-table-products"
                onError={e => {
                  e.target.onerror = null
                  e.target.src = NoImage
                }}
              />
            )}
            <span>{description}</span>
          </div>
        )
      },
    },
    {
      Header: t('CUSTOMER_DISPLAY.QTY_HEADER'),
      accessor: t('CUSTOMER_DISPLAY.QTY_ACCESOR'),
      width: '10%',
    },
    {
      Header: t('CUSTOMER_DISPLAY.UNITY_PRICE_HEADER'),
      accessor: t('CUSTOMER_DISPLAY.UNITY_PRICE_ACCESOR'),
      width: '10%',
    },
    {
      Header: t('CUSTOMER_DISPLAY.DISCOUNT_HEADER'),
      accessor: t('CUSTOMER_DISPLAY.DISCOUNT_ACCESOR'),
      width: '10%',
    },
    {
      Header: t('CUSTOMER_DISPLAY.PRECIO_TOTAL_HEADER'),
      accessor: t('CUSTOMER_DISPLAY.PRECIO_TOTAL_ACCESOR'),
      width: '10%',
    },
  ]

  return (
    <>
      <div
        className="container-detail-quote"
        data-testid="container-detail-quote">
        {isLoadingDetailQuote ? (
          <Loading full />
        ) : (
          <>
            <h1 className="title-detail-quote" data-testid="title-detail-quote">
              {t('CUSTOMER_DISPLAY.TITLE_DETAIL_QUOTE')}
              {quoteDocumentNumber && (
                <span
                  className="font-weight"
                  data-testid="text-document-number">
                  {quoteDocumentNumber}
                </span>
              )}
            </h1>
            <div
              className="container-information-quote"
              data-testid="container-information-quote">
              <div
                className="info-customer"
                data-testid="container-customer-info">
                <p data-testid="text-customer-name">
                  {t('CUSTOMER_DISPLAY.CUSTOMER_NAME', {
                    customer:
                      quote?.CustomerFullName || quote?.CustomerNameDocument,
                  })}
                </p>
                <p data-testid="text-customer-email">
                  {t('CUSTOMER_DISPLAY.CUSTOMER_EMAIL', {
                    email: quote?.CustomerEmail,
                  })}
                </p>
                <p data-testid="text-customer-phone">
                  {t('CUSTOMER_DISPLAY.CUSTOMER_PHONE', {
                    phone: quote?.Telephone_Number || quote?.Telephone,
                  })}
                </p>
              </div>
              <div
                className="info-delivery-method"
                data-testid="container-delivery-method">
                {quote?.Address_AddressId ? (
                  <>
                    <p
                      className="font-weight"
                      data-testid="text-delivery-type-home">
                      {t('CUSTOMER_DISPLAY.DELIVERY_HOME')}
                    </p>
                    <p data-testid="text-delivery-address">
                      {t('CUSTOMER_DISPLAY.ADDRESS', {
                        address: quote?.Address_AddressDetail,
                      })}
                    </p>
                    <p data-testid="text-delivery-location">
                      {`${quote?.Address_CountryName}, ${quote?.Address_ProvinceName}, ${quote?.Address_DistrictName}, ${quote?.Address_TownshipName}`}{' '}
                    </p>
                    <p data-testid="text-delivery-alias">
                      {t('CUSTOMER_DISPLAY.ALIAS', {
                        alias: quote?.Address_AddressName,
                      })}
                    </p>
                  </>
                ) : (
                  <>
                    <p
                      className="font-weight"
                      data-testid="text-delivery-type-warehouse">
                      {t('CUSTOMER_DISPLAY.DELIVERY_WAREHOUSE')}
                    </p>
                    <p data-testid="text-warehouse-description">
                      {quote?.WarehouseDescription}
                    </p>
                    <p data-testid="text-warehouse-address">
                      {t('CUSTOMER_DISPLAY.ADDRESS', {
                        address: quote?.WarehouseAddress,
                      })}
                    </p>
                  </>
                )}
              </div>
            </div>
            {quote?.Lines && (
              <ProductsTable
                data={products}
                columns={columns}
                hideFooter={true}
                isProductPage={false}
                showDiscount={showDiscount}
                totals={[
                  {
                    SubTotal: showDiscount ? quote?.SubTotal : quote?.Amount,
                    Discount: quote?.DiscountAmount,
                    Tax: quote?.Tax,
                    Total:
                      quote?.Tax > 0 ? quote?.AmountWithTax : quote?.Amount,
                  },
                ]}
              />
            )}
          </>
        )}
      </div>
    </>
  )
}
